// Shared template for empty + error screens (matches Hi-Fi Empty Closet + Try-on Error).
// Per docs/design-spec.md §4.5.

export default function EmptyState({ icon, title, body, actions, iconShape = 'rounded' }) {
  return (
    <div className="empty-state">
      <div className={`empty-icon-tile ${iconShape}`}>{icon}</div>
      <div>
        <h2>{title}</h2>
        {body && <p>{body}</p>}
      </div>
      {actions && <div className="empty-actions">{actions}</div>}
    </div>
  );
}
